/**
 * @file actions/Page/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const MEDIA_QUERY_SMALL = "40em";
export const MEDIA_QUERY_MEDIUM = "60em";

export const VIEWPORT_DEFAULTS = {
    moreButton: 180,
    maxWidth: 1300,
    mobileWidth: 640,
    wallpaperWidth: 1024,
};

export const THROTTLES = {
    scroll: 50,
    resize: 300,
    default: 100,
};
